// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"12097d30","518":"8af7b9f1","618":"71a80fc2","905":"e4aff47f","926":"4aa9f842","989":"dbc64f1b"}[chunkId] + ".chunk.js";
};